<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="8">
        <h2>Compliance</h2>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="4">
            <v-menu
              ref="menu1"
              v-model="menu1"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu
              ref="menu2"
              v-model="menu2"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="endDate"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <nutrition-product-compliance :start-date="startDate" :end-date="endDate" />
      </v-col>
      <v-col cols="12">
        <weekly-compliance :start-date="startDate" :end-date="endDate" />
      </v-col>
      <v-col cols="12">
        <recipe-views-per-date
          :start-date="startDate"
          :end-date="endDate"
          :uniqueUsers="true"
          title="Users who viewed a recipe"
        />
      </v-col>
      <v-col cols="12">
        <recipe-views-per-date :start-date="startDate" :end-date="endDate" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NutritionProductCompliance from "@/components/reporting/blocks/NutritionProductCompliance";
import RecipeViewsPerDate from "@/components/reporting/blocks/RecipeViewsPerDate";
import WeeklyCompliance from "@/components/reporting/blocks/WeeklyCompliance";

export default {
  name: "ComplianceSummary",
  components: {
    NutritionProductCompliance,
    RecipeViewsPerDate,
    WeeklyCompliance,
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
    };
  },
};
</script>
